import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './QuickLoan.css'; 
import { useNavigate } from 'react-router-dom';

const QuickLoan = () => {
   
    const [loans, setLoans] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // Pagination States
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const superAdminId = localStorage.getItem("adminuserId");

    const navigate = useNavigate();
    
    const handleView = (loan) => {
        navigate('/viewquickloanreport', { state: { loan } });
    };

    const fetchLoanReport = async (page) => {
        setLoading(true);
        try {
            const response = await axios.get(
                `https://payyug.in/api/dashboard-loan/report?superAdminId=${superAdminId}&page=${page}`
            );
            
            if (response.data.success) {
                setLoans(response.data.data);
                setTotalPages(response.data.totalPages);
                setCurrentPage(response.data.currentPage);
            } else {
                setError("Failed to fetch records");
            }
        } catch (err) {
            setError(err.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLoanReport(currentPage);
    }, [currentPage]);

    if (loading && loans.length === 0) return <div className="loan-status-msg">Loading loan reports...</div>;
    if (error) return <div className="loan-error-msg">Error: {error}</div>;

    return (
        <div className="quick-loan-container">
            <div className="loan-header">
                <h2>Quick Loan Report</h2>
            </div>
            
            <div className="quick-loan-table-wrapper">
                <table className="loan-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Customer Details</th>
                            <th>Loan ID</th>
                            <th>Mobile</th>
                            <th>Loan Type</th>
                            <th>Amount</th>
                            <th>Tenure</th>
                            <th>Status</th>
                            <th>Applied On</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loans.length==0? "No records found...":
                           loans.map((loan,index) => (
                            <tr key={loan.id}>
                                <td>{(currentPage-1)*10+index+1}</td>
                                
                                <td>
                                    <div className="cust-name">{loan.fullName}</div>
                                    <div className="cust-email">{loan.email}</div>
                                </td>
                                <td>{loan.id}</td>
                                <td>{loan.mobile}</td>
                                <td>{loan.loanType}</td>
                                <td className="amount-cell">₹{loan.loanAmount.toLocaleString()}</td>
                                <td>{loan.loanTenureMonths} Months</td>
                                
                                <td>
                                    <span className={`status-badge ${(loan.status || 'pending').toLowerCase()}`}>
                                        {loan.status || 'Pending'}
                                    </span>
                                </td>
                                
                                <td>{new Date(loan.createdAt).toLocaleDateString("en-IN")}</td>
                                <td className="view-cell" onClick={() => handleView(loan)}> <button>View</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="pagination-container">
                <button 
                    className="paging-btn"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(prev => prev - 1)}
                >
                    Previous
                </button>
                
                <span className="paging-info">
                    Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
                </span>
                
                <button 
                    className="paging-btn"
                    disabled={currentPage >= totalPages}
                    onClick={() => setCurrentPage(prev => prev + 1)}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default QuickLoan;